module.exports = __webpack_public_path__ + "img/loginIcon.0507107c.png";